module.exports = __webpack_public_path__ + "static/media/sober-eye-virtual-glass.c62bd581.webp";